var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center"},[_c('div',{staticClass:"pa-2",staticStyle:{"max-width":"600px"}},[_c(_vm.WordSystems || _vm.$g.NotTranslated,{tag:"component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }